module.exports = __webpack_public_path__ + "img/ceb.28645d32.jpg";